"use strict";

var criticalInput = require("./../../../../critical-input.json");
module.exports = {
  region: criticalInput.region,
  IDENTITY_POOL_ID: criticalInput.IdentityPoolId,
  AWS_PROJECT_REGION: criticalInput.AWS_PROJECT_REGION,
  AWS_APPSYNC_GRAPHQLENDPOINT: criticalInput.AWS_APPSYNC_GRAPHQLENDPOINT,
  AWS_APPSYNC_REGION: criticalInput.AWS_APPSYNC_REGION,
  AWS_APPSYNC_AUTHENTICATIONTYPE: criticalInput.AWS_APPSYNC_AUTHENTICATIONTYPE,
  AWS_APPSYNC_APIKEY: criticalInput.AWS_APPSYNC_APIKEY,
  ESTIMATOR_WHATIFS_API1_LAMBDA: criticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA,
  ESTIMATOR_WHATIFS_API2_LAMBDA: criticalInput.ESTIMATOR_WHATIFS_API2_LAMBDA,
  NON_PROD_ENV: criticalInput.NON_PROD_ENV,
  BBL_NODE_API_PACLIFE_QUOTE_URL: criticalInput.BBL_NODE_API_PACLIFE_QUOTE_URL,
  PACLIFE_BASE_URL: criticalInput.PACLIFE_BASE_URL,
  URL_ENV_MAP: criticalInput.URL_ENV_MAP
};